"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 18,
    sm: 22,
    md: 28,
    lg: 34,
    xl: 44,
};
exports.default = react_jss_1.createUseStyles({
    filled: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
            color: theme.white,
            '&:not(:disabled):hover': {
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 7 }),
            },
            '&:disabled': {
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: 'gray',
                    shade: theme.colorScheme === 'dark' ? 8 : 1,
                }),
            },
        });
    },
    light: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 0 }),
            color: theme.colorScheme === 'dark'
                ? theme.colors.dark[9]
                : theme_1.getThemeColor({ theme: theme, color: color, shade: 9 }),
            '&:not(:disabled):hover': {
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 5 : 1,
                }),
            },
            '&:disabled': {
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: 'gray',
                    shade: theme.colorScheme === 'dark' ? 8 : 1,
                }),
            },
        });
    },
    hover: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            backgroundColor: 'transparent',
            '&:not(:disabled):hover': {
                backgroundColor: theme.colorScheme === 'dark'
                    ? theme.colors.dark[8]
                    : theme_1.getThemeColor({ theme: theme, color: color, shade: 0 }),
            },
        });
    },
    transparent: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            backgroundColor: 'transparent',
        });
    },
    actionIcon: function (_a) {
        var radius = _a.radius, theme = _a.theme, size = _a.size;
        return (__assign(__assign(__assign({}, theme_1.getFocusStyles(theme)), theme_1.getFontStyles(theme)), { appearance: 'none', WebkitAppearance: 'none', WebkitTapHighlightColor: 'transparent', border: '1px solid transparent', boxSizing: 'border-box', height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), minHeight: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), minWidth: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }), padding: 0, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'color 100ms ease, background-color 100ms ease', '&:not(:disabled):active': {
                transform: 'translateY(1px)',
            }, '&:disabled': {
                color: theme.colors.gray[theme.colorScheme === 'dark' ? 6 : 4],
                cursor: 'not-allowed',
            } }));
    },
    outline: function (_a) {
        var theme = _a.theme, color = _a.color;
        return ({
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            backgroundColor: 'transparent',
            borderColor: theme_1.getThemeColor({
                theme: theme,
                color: color,
                shade: theme.colorScheme === 'dark' ? 4 : 6,
            }),
            '&:not(:disabled):hover': {
                backgroundColor: theme.colorScheme === 'dark'
                    ? theme.colors.dark[8]
                    : theme_1.getThemeColor({ theme: theme, color: color, shade: 0 }),
            },
            '&:disabled': {
                borderColor: theme.colors.gray[theme.colorScheme === 'dark' ? 7 : 3],
            },
        });
    },
}, { link: true });
